<template>
<div class="main">

  <div class="container">

    <div class="placeholder ut-mt-4 ut-mb-8">
      <img class="ut-m-auto ut-block" src="@/assets/images/recomendation.svg">
    </div>
    <h1 class="ut-font-semibold ut-text-center ut-text-xl ut-mb-4">How our recommendation algorithm&nbsp;works</h1>

    <ol>
      <li>We analyse every property sale in Australia to get to know who the best agents&nbsp;are</li>
      <li>We ask you questions to understand your specific selling&nbsp;situation</li>
      <li>We then use all of our knowledge to find the three agents you should be talking to if you want to sell your&nbsp;home</li>
    </ol>

    <router-link class="ut-oa-btn ut-mt-4 ut-block " :to="{name: 'PersonalisedShortlistStep1'}" v-gaEvent="{ category: 'Personalised Short List Form', action: 'Click Start', label: ''}">Start</router-link>

  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PersonalisedShortlist',
  components: {
  },

  data() {
    return {
      errors: [],
    };
  },
  methods: {
    addValue(value) {
      return value;
    },
  },

  created() {},
};
</script>

<style scoped lang="scss">
.container {
    padding: 25px;
    max-width: 600px;

    .nopoint {
        @apply ut-text-base;
        padding: 15px 0;
    }

    ol {
        counter-reset: item;
        margin: 30px 0 1.5em;
        padding: 0;
        > li {
            margin: 20px 0;
            counter-increment: item;
            list-style-type: none;
            padding: 0 0 0 1.5rem;
            text-indent: -1.2rem;
            line-height: 22px;
            &::before {
                margin-left: -15px;
                content: counter(item) '.';
                display: inline-block;
                font-weight: bold;
                padding-right: 0.6rem;
                text-align: right;
                width: 1.5rem;
            }
        }
    }
}
</style>
